import React, { useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import useTransactionLog from 'tennders-transactions/hooks/useTransactionLog'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import useSocket from 'tennders-common/hooks/useSocket'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import TruckHistory from './TruckHistory'

type Props = {
  id ?: string,
  isSingleView ?: boolean
  shouldShowCommentsOnly ?: boolean
}

export const HistoryTrucks = React.memo(({ id, isSingleView, shouldShowCommentsOnly }: Props) => {
  const { t } = useTranslation()
  const { logs, fetchTruckHistory, nomore } = useTransactionLog('trucks', shouldShowCommentsOnly)
  const { refresh } = useSocket()
  const { transaction } = useTransaction()

  useEffect(() => {
    if (refresh === `${REFRESH_TYPES.TLOG_TRUCK}-${id}`) {
      fetchTruckHistory(id, true)
    }
  }, [refresh])

  return (
    logs.length === 0 && !transaction?.id
      ? <div className="text-center">{t('transactionHistory:no_logs_yet')}</div>
      : (
        <TruckHistory
          id={id}
          more={!nomore}
          loadMore={() => fetchTruckHistory(id)}
          isSingleView={isSingleView}
          logs={logs}
          loading={false}
          refreshKey={`${REFRESH_TYPES.TLOG_TRUCK}-${id}`}
          onRefresh={() => fetchTruckHistory(id, true)}
        />
      )
  )
})
